export type PurchasingTab = "purchaseOrders" | "vendors" | "receipts" | "outlook" | "settings";

export const PURCHASING_TABS: ReadonlyArray<{
  id: PurchasingTab;
  label: string;
  description: string;
}> = [
  {
    id: "purchaseOrders",
    label: "Purchase orders",
    description:
      "Draft, issue, record the vendor invoice, then confirm delivery (quality + chargebacks) into inventory.",
  },
  {
    id: "vendors",
    label: "Vendors",
    description:
      "Add and edit the vendor directory used on purchase orders (name, contact, phone, email, address).",
  },
  {
    id: "receipts",
    label: "Invoice receipts",
    description:
      "Upload vendor invoices (PDF/image), Review to OCR header + lines, and post matched lines.",
  },
  {
    id: "outlook",
    label: "Outlook",
    description: "Shortages, order mapping, indicator rules, and the scheduled email.",
  },
  {
    id: "settings",
    label: "Settings",
    description: "PO numbering prefix/next number and default confirmation message.",
  },
];

export function purchasingTabsForSeat(plantOnly: boolean) {
  if (!plantOnly) return PURCHASING_TABS;
  return PURCHASING_TABS.filter((t) => t.id === "purchaseOrders" || t.id === "receipts");
}
